<template>
  <li
    v-if="canViewVerticalNavMenuGroup(item)"
    class="dropdown dropdown-submenu"
    :class="{
      'show': isOpen,
      'disabled': item.disabled,
      'sidebar-group-active active open': isActive,
      'openLeft': openChildDropdownOnLeft
    }"
    @mouseenter="() => updateGroupOpen(true)"
    @mouseleave="() => updateGroupOpen(false)"
  >
    <b-link
      class="dropdown-item"
      href="#"
      :class="{'dropdown-toggle': item.children}"
      @click="() => updateGroupOpen(!isOpen)"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />
      <span class="menu-title">{{ t(item.title) }}</span>
    </b-link>
    <ul
      ref="refChildDropdown"
      class="dropdown-menu"
    >
      <component
        :is="resolveNavItemComponent(child)"
        v-for="child in item.children"
        :key="child.header || child.title"
        v-if="handleShowMenu(child.header || child.title, profileData.role)"
        ref="groupChild"
        :item="child"
      />
    </ul>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'
import { BLink } from 'bootstrap-vue'
import { resolveHorizontalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { useUtils as useAclUtils } from '@core/libs/acl'
import HorizontalNavMenuLink from '../horizontal-nav-menu-link/HorizontalNavMenuLink.vue'
import MenuReportPermission, { restrictedReportPermission } from '@/common/permission/menu/report'

// Composition Function
import useHorizontalNavMenuGroup from './useHorizontalNavMenuGroup'
import mixinHorizontalNavMenuGroup from './mixinHorizontalNavMenuGroup'

export default {
  name: 'HorizontalNavMenuGroup',
  components: {
    HorizontalNavMenuLink,
    BLink,
  },
  mixins: [mixinHorizontalNavMenuGroup],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      profileData: 'User/user',
    })
  },
  data () {
    return {
      menuReportPermission: MenuReportPermission,
      restrictedReportPermission: restrictedReportPermission,
      handleHeader: [
        'Report',
        'Ticket Detail Report (New)',
        'Ticket Summary By Agent', 
        'Ticket Summary By Channel',
        'Ticket Summary By Case Type',
        'Detail Report'
      ],
      restrictedReportHeader: [
        'Categories',
        'Complain Report'
      ]
    }
  },
  methods: {
    handleShowMenu(header, role) {
      if (!header || !role) {
        return true // แสดงเมนูถ้าไม่มีข้อมูล
      }
      
      // ตรวจสอบ Categories Report และ Complain Report ก่อน (Super Admin เท่านั้น)
      if(this.restrictedReportHeader.includes(header) && !this.restrictedReportPermission.includes(role)) {
        return false
      }
      
      // ตรวจสอบ Report ทั่วไป
      if(this.handleHeader.includes(header) && !this.menuReportPermission.includes(role)) {
        return false
      }
      
      return true
    }
  },
  setup(props) {
    const {
      refChildDropdown,
      isActive,
      isOpen,
      updateGroupOpen,
      updateIsActive,
      openChildDropdownOnLeft,
    } = useHorizontalNavMenuGroup(props.item)

    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuGroup } = useAclUtils()

    return {
      refChildDropdown,
      openChildDropdownOnLeft,
      resolveNavItemComponent,
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuGroup,

      // i18n
      t,
    }
  },
}
</script>

<style>

</style>
